<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="goToBack()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                Home-Connect SMS tool
            </span>
        </div>
    </div>
    <div class="card card_content">
        <div class="cssmtgb just_center">
            <mat-tab-group animationDuration="1000ms" mat-stretch-tabs mat-align-tabs="start"
                (selectedTabChange)="onTabChange($event)">
                <mat-tab label="Individual">
                    <hr>
                    <form [formGroup]="searchform">
                        <div class="row mt-4 d-flex justify-content-center">
                            <div class="col-md-4 padd-right-file" style="display: flex;">
                                <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
                                    <mat-label>Search</mat-label>
                                    <div class="search-input-container">
                                        <input placeholder="Enter Name / Email / Reference Number / Mobile Number"
                                            formControlName="searchQuery" id="search" matInput type="text" #searchInput>
                                    </div>
                                </mat-form-field>
                                <button matSuffix mat-icon-button aria-label="Search"
                                    class="badge bg-light-blue image-button" (click)="searchUser()">
                                    <mat-icon style="color: white;">search</mat-icon>
                                </button>
                            </div>
                            <button type="button" class="btn reset_btn mr-2" (click)="reset()">
                                <i class="fa fa-refresh"></i> Reset
                            </button>
                        </div>
                    </form>
                    <div class="table-responsive mt-2 mt-4">
                        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">
                            <ng-container matColumnDef="FirstName">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="FirstName">First Name
                                </mat-header-cell>
                                <mat-cell *matCellDef="let dataField" (click)="selectedUserClick(dataField)">
                                    <p class="text-truncate txtalign">
                                        {{dataField.firstName}}</p>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="LastName">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="LastName">Last Name
                                </mat-header-cell>
                                <mat-cell *matCellDef="let dataField" (click)="selectedUserClick(dataField)">
                                    <p class="text-truncate txtalign">
                                        {{dataField.lastName}}</p>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="Email">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="Email">Email</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" (click)="selectedUserClick(dataField)">
                                    <p class="text-truncate txtalign">
                                        {{dataField.email}}</p>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="MobileNumber">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="MobileNumber">Mobile
                                    Number</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" (click)="selectedUserClick(dataField)">
                                    <p class="text-truncate txtalign">
                                        {{dataField.mobileNumber }}</p>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="ReferenceNumber">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="ReferenceNumber">Reference
                                    Number</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" (click)="selectedUserClick(dataField)">
                                    <p class="text-truncate txtalign">
                                        {{dataField.refrenceNumber }}</p>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;"
                                [ngClass]="{'highlight-row': selectedRow === row}" matRipple>
                            </mat-row>
                        </mat-table>
                        <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                            <p>No data found</p>
                        </div>
                    </div>
                    <div class="container my-4" *ngIf="showmessagebox">
                        <div class="row">
                            <div class="col-12">
                                <span class="title_header_bar"> Customer Details</span>
                            </div>
                        </div>
                        <div class="card card_content">
                            <form [formGroup]="userdetailsForm">
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Name</mat-label>
                                            <input matInput appInputtext maxlength="25" formControlName="fullName"
                                                placeholder="Enter Account Number" class="col-10" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Customer No</mat-label>
                                            <input matInput maxlength="25" formControlName="refrenceNumber"
                                                placeholder="Enter Account Number" class="col-10" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Email</mat-label>
                                            <input matInput formControlName="email" placeholder="Enter Account Number"
                                                class="col-10" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Mobile</mat-label>
                                            <input matInput maxlength="15" formControlName="mobileNumber"
                                                placeholder="Enter Account Number" class="col-10" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-8 col-xl-5 mt-5">
                                <div class="col-sm-12 col-md-6" style="display: flex; align-items: center;">
                                    <mat-checkbox style="transform: scale(1.3);" (change)="requestBankChange($event)"
                                        color="primary"></mat-checkbox>
                                    <label style="margin-left: 30px; font-size: large; white-space: nowrap;">
                                        Request Banking details Update
                                    </label>
                                </div>
                            </div>
                            <div class="col-xl-6 mt-5" *ngIf="showmessage" style="font-size: large;color: #90a;">
                                <p>* Request to update bank detail for the above Specified user</p>
                            </div>
                        </div>
                        <div class="card card_content mt-4" *ngIf="!showmessage">
                            <form [formGroup]="singleMessageForm">
                                <div class="row">
                                    <div class="col-sm-12 col-md-1">
                                    </div>
                                    <div class="col-sm-12 col-md-5 mt-4">
                                        <div class="col-sm-12 col-md-12 align-self-center mt-3"
                                            style="display: flex; align-items: center;">
                                            <label style="margin-right: 30px; font-size: large;">Notification
                                                Type</label>
                                            <mat-radio-group formControlName="messageNotificationType"
                                                (change)="smsormail($event)"
                                                style="display: flex; flex-direction: row; gap: 80px;">
                                                <mat-radio-button value="1">SMS</mat-radio-button>
                                                <mat-radio-button class="ml-3" value="2">Email</mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-5 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Recipient</mat-label>
                                            <input matInput maxlength="25" formControlName="Recipent"
                                                placeholder="Enter Account Number" class="col-10" autocomplete="off">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row" *ngIf="showsub">
                                    <div class="col-xl-1"></div>

                                    <div class="col-sm-12 col-md-5 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Subject</mat-label>
                                            <input matInput formControlName="subject" placeholder="Enter the Subject"
                                                class="col-10" autocomplete="off" appInputtext
                                                (keydown.space)="preventLeadingSpace($event)">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row mt-3" *ngIf="showsub">
                                    <div class="col-xl-1"></div>
                                    <div class="col-xl-8">
                                        <div class="editor" style="background: white;">
                                            <quill-editor formControlName="message" [modules]="toolbarModules"
                                                style="background: white;"></quill-editor>
                                        </div>
                                    </div>
                                    <div class="col-xl-2"></div>
                                </div>
                                <div class="row" *ngIf="!showsub">

                                    <div class="col-xl-1"></div>
                                    <div class="col-sm-12 col-md-10 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker
                                            [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                                            <mat-label>Message</mat-label>
                                            <textarea rows="4" matInput type="text" placeholder="Enter Message"
                                                (input)="counttext()" formControlName="message" autocomplete="off"
                                                specialIsAlphaNumeric class="col-12"
                                                (keydown.space)="preventLeadingSpace($event)"></textarea>
                                        </mat-form-field>
                                    </div>

                                    <div class="col mt-4" style="margin-left:  6rem; font-size: medium;"
                                        *ngIf="!showsub">
                                        <p>Text Characters Count : {{messageCount}}</p>
                                    </div>
                                </div>

                            </form>
                        </div>
                        <div class="mt-4 mr-4" style="text-align: end;">
                            <button type="button" matRipple class="btn btn-primary" (click)="singleMessageSend()">
                                Submit
                            </button>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Group">
                    <hr>
                    <form [formGroup]="groupForm">
                        <div class="row mt-3">
                            <div class="col-xl-2"></div>
                            <div class="col-xl-8">
                                <div class="row">

                                </div>
                                <div class="row">
                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Service Provider</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="serviceProvider"
                                                placeholder="Please Select Service Provider"
                                                [disabled]="isDisableServiceProvider"
                                                (selectionChange)="onChangeServiceProvider()">
                                                <mat-select-filter [displayMember]="'value'"
                                                    [array]="serviceProviderList"
                                                    (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                                                <mat-option *ngFor="let item of filteredList1" [value]="item.key"
                                                    style="overflow-y: scroll !important;">
                                                    {{item.value}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Application Status</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="applicationStatus"
                                                placeholder="Please Select Application Status">
                                                <mat-select-filter [displayMember]="'value'"
                                                    [array]="applicationStatusList"
                                                    (filteredReturn)="filteredList2 = $event"></mat-select-filter>
                                                <mat-option *ngFor="let item of filteredList2" [value]="item.key"
                                                    style="overflow-y: scroll !important;">
                                                    {{item.value}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>Province</mat-label>
                                            <mat-select class="scrollbarcs" formControlName="city"
                                                placeholder="Please Select Province" [disabled]="isDisableCity"
                                                (selectionChange)="oncitychange()">
                                                <mat-select-filter [displayMember]="'value'" [array]="provinceList"
                                                    (filteredReturn)="filteredList3 = $event"></mat-select-filter>
                                                <mat-option *ngFor="let item of filteredList3" [value]="item.value"
                                                    style="overflow-y: scroll !important;">
                                                    {{item.value}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-sm-12 col-md-6 mt-4">
                                        <ng-multiselect-dropdown formControlName="complex"
                                            placeholder="Select The Complex" [settings]="dropdownSettings"
                                            [data]="complexList" (onSelect)="oncomplexchange()"
                                            (onDeSelect)="oncomplexchange()">
                                        </ng-multiselect-dropdown>
                                    </div>

                                    <div class="col-xl-6 mt-4">
                                        <mat-form-field appearance="fill" hideRequiredMarker>
                                            <mat-label>City / Suburb</mat-label>
                                            <input matInput maxlength="50" formControlName="cityText"
                                                placeholder="Enter City / Suburb" class="col-12" autocomplete="off"
                                                (input)="typecity()">
                                        </mat-form-field>
                                    </div>

                                    <div class="col-xl-6 mt-4">
                                        <mat-checkbox style="transform: scale(1.3);" color="primary"
                                            [checked]="isSmsForAdminChecked"
                                            (change)="CheckboxSmsAdmin($event)"></mat-checkbox>
                                        <label style="margin-left:12px; font-size: large; white-space: nowrap;">
                                            Do you want to send SMS to admin?
                                        </label>
                                    </div>
                                    <div class="card card_content col-12 mt-4" style="border-radius: 10px !important;"
                                        *ngIf="isSmsForAdminChecked">

                                        <div class="col-xl-12 d-flex align-items-center">

                                            <div class="col-sm-12 col-md-6" style="display: flex;">
                                                <div class="css27">
                                                    <mat-form-field appearance="fill" hideRequiredMarker
                                                        style="width: 60px !important;">
                                                        <mat-label>+27</mat-label>
                                                        <input readonly matInput maxlength="10" type="text"
                                                            id="mobileNumberLabel" placeholder="+27" autocomplete="off"
                                                            class="col-12">
                                                    </mat-form-field>
                                                </div>
                                                <div class="css272" style="width: 100%;">
                                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                                        <mat-label>Mobile Number</mat-label>
                                                        <input matInput maxlength="9" type="text" id="mobileNumber"
                                                            placeholder="Enter Admin Mobile Number"
                                                            formControlName="mobileNumber" autocomplete="off"
                                                            class="col-12" minlength="9"
                                                            (keypress)="onlyNumbersWithZero($event)">
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-xl-12">
                                                <button type="button" class="btn btn-primary text-nowrap"
                                                    (click)="addAdmin()">
                                                    <i class="fa fa-plus"></i> Add Mobile Number
                                                </button>
                                                <button class="btn reset_btn ml-3 " (click)="resetAdmin()">
                                                    <i class="fa fa-refresh"></i> Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-12 mt-4" *ngIf="adminMobileNumbers.length > 0">
                                        <mat-form-field appearance="fill" hideRequiredMarker
                                            [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                                            <mat-label>Admin Mobile Number List</mat-label>
                                            <textarea rows="3" matInput autocomplete="off" class="col-12" readonly
                                                [value]="adminMobileNumbers.join(', ')"></textarea>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-xl-6"></div>
                                    <div class="col-12 mt-4 d-flex justify-content-center">
                                        <button class="btn reset_btn mr-3 " (click)="reset()">
                                            <i class="fa fa-refresh"></i> Reset
                                        </button>
                                        <button class="btn btn-secondary mr-3" *ngIf="showSearch" (click)="Onchange()">
                                            <i class="fa fa-search"></i> Search
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2"></div>
                        </div>
                    </form>
                    <div class="table-responsive table-container mt-2 mb-4">
                        <mat-table #table [dataSource]="dataSource" class="mat-table ">

                            <ng-container matColumnDef="Action">
                                <mat-header-cell *matHeaderCellDef style="text-align: center; width: 3%;">
                                    <mat-checkbox [(ngModel)]="masterChecked"
                                        (change)="toggleAllCheckboxes($event)"></mat-checkbox>
                                </mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="text-align: center;">
                                    <mat-checkbox [checked]="isSelected(dataField)"
                                        (change)="onCheckboxChange(dataField)">
                                    </mat-checkbox>
                                </mat-cell>
                            </ng-container>


                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
                                <mat-cell *matCellDef="let dataField let i = index"
                                    (click)="onCheckboxChange(dataField)"> {{dataField.name ? dataField.name : '-'}}
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="Name">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;">
                                    Name</mat-header-cell>
                                <mat-cell *matCellDef="let dataField let i = index"
                                    (click)="onCheckboxChange(dataField)" style="width: 8%;text-align: center;">
                                    <p class="text-truncate txtalign">{{dataField.customerName ? dataField.customerName
                                        : '-' }} </p>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="Email">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;">Email</mat-header-cell>
                                <mat-cell *matCellDef="let dataField let i = index"
                                    (click)="onCheckboxChange(dataField)" style="width: 5%; text-align: center;">
                                    <p class="text-truncate txtalign">{{dataField.email ? dataField.email : '-'}}</p>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="ContactNo">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;">Contact
                                    No</mat-header-cell>
                                <mat-cell *matCellDef="let dataField let i = index"
                                    (click)="onCheckboxChange(dataField)" style="width: 4%;text-align: center;">
                                    <p class="text-truncate txtalign">
                                        {{
                                        dataField.mobileNumber?.startsWith('+')
                                        ? dataField.mobileNumber
                                        : '+' + dataField.mobileNumber
                                        }}
                                    </p>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="CustomerNumber">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;">Customer
                                    Number</mat-header-cell>
                                <mat-cell *matCellDef="let dataField let i = index"
                                    (click)="onCheckboxChange(dataField)" style="width: 4%;text-align: center;">
                                    <p class="text-truncate txtalign">
                                        {{dataField.customerReferenceNumber ? dataField.customerReferenceNumber : '-' }}
                                    </p>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="Address">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;">Address</mat-header-cell>
                                <mat-cell *matCellDef="let dataField let i = index"
                                    (click)="onCheckboxChange(dataField)" style="width: 15%;text-align: center;">
                                    <p class="text-truncate txtalign">
                                        {{ dataField.address ? 'R ' + dataField.address : '-' }}
                                    </p>
                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumns1; sticky:true"></mat-header-row>

                            <mat-row *matRowDef="let row; columns: displayedColumns1;  " matRipple>
                            </mat-row>
                        </mat-table>
                        <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                            <p>No data found</p>
                        </div>

                    </div>
                    <div class="table_pagenation">
                        <mat-paginator #paginator [length]="dataSource?.data.length || 0" [pageIndex]="0"
                            [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
                        </mat-paginator>
                    </div>


                    <div class="card card_content mt-4" *ngIf="showmessagebox">
                        <form [formGroup]="groupMessageForm">
                            <div class="row">
                                <div class="col-sm-12 col-md-1">
                                </div>
                                <div class="col-sm-12 col-md-5 mt-4">
                                    <div class="col-sm-12 col-md-12 align-self-center mt-3"
                                        style="display: flex; align-items: center;">
                                        <label style="margin-right: 30px; font-size: large;">Notification
                                            Type</label>
                                        <mat-radio-group formControlName="messageNotificationType"
                                            (change)="smsormail($event)"
                                            style="display: flex; flex-direction: row; gap: 80px;">
                                            <mat-radio-button value="1">SMS</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-xl-1"></div>

                                <div class="col-sm-12 col-md-5 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Subject</mat-label>
                                        <input matInput formControlName="subject" placeholder="Enter the sub"
                                            class="col-10" autocomplete="off"
                                            (keydown.space)="preventLeadingSpace($event)">

                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xl-1"></div>
                                <div class="col-sm-12 col-md-11 align-self-center mt-3"
                                    style="display: flex; align-items: center;">
                                    <label style="margin-right: 30px; font-size: large;">Category
                                        Type</label>
                                    <mat-radio-group formControlName="categoryType"
                                        style="display: flex; flex-direction: row; gap: 16px;"
                                        (change)="categoryType()">
                                        <mat-radio-button value="4" style="padding: 16px;">New</mat-radio-button>
                                        <mat-radio-button value="1"
                                            style="padding-right: 16px;">Notification</mat-radio-button>
                                        <mat-radio-button value="2"
                                            style="padding-right: 16px;">Maintenance</mat-radio-button>
                                        <mat-radio-button value="3">Resolution</mat-radio-button>


                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="row" *ngIf="showtemplate">
                                <div class="col-md-1"></div>
                                <div class="col-xl-5 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker>
                                        <mat-label>Select Template</mat-label>
                                        <mat-select class="scrollbarcs" formControlName="template"
                                            placeholder="Please Select Template" (selectionChange)="selectTemplate()">
                                            <mat-select-filter [displayMember]="'value'" [array]="templateList"
                                                (filteredReturn)="templateList = $event"></mat-select-filter>
                                            <mat-option *ngFor="let item of templateList" [value]="item.key"
                                                style="overflow-y: scroll !important;">
                                                {{item.value}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">

                                <div class="col-xl-1"></div>
                                <div class="col-sm-12 col-md-10 mt-4">
                                    <mat-form-field appearance="fill" hideRequiredMarker
                                        [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                                        <mat-label>Message</mat-label>
                                        <textarea rows="10" matInput type="text" placeholder="Enter Message"
                                            (input)="counttext()" formControlName="message" autocomplete="off"
                                            (keydown.space)="preventLeadingSpace($event)">

                                            specialIsAlphaNumeric class="col-12"></textarea>
                                    </mat-form-field>
                                </div>

                                <div class="col mt-4" style="margin-left:  6rem; font-size: medium;">
                                    <p>Text Characters Count : {{messageCount}}</p>
                                </div>
                            </div>

                        </form>
                    </div>

                    <div class="mt-4 mr-4" style="text-align: end;" *ngIf="showmessagebox">
                        <button type="button" matRipple class="btn btn-primary" (click)="groupMessageSend()">
                            Submit
                        </button>
                    </div>

                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>